import { toggleFixed } from '../actions/ui'

const DocumentEffects = {
  register() {
    return {
      [toggleFixed]: this.toggleFixed
    }
  },

  toggleFixed(repo, shouldFix) {
    const method = shouldFix ? 'add' : 'remove'
    document.body.classList[method]('fixed')
  }
}

export default DocumentEffects



// WEBPACK FOOTER //
// ./src/effects/document.js